import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import DailyTaskManagement from './pages/daily-task-management';
import FamilyCalendarView from './pages/family-calendar-view';
import LongTermTaskPlanning from './pages/long-term-task-planning';
import FamilySettingsManagement from './pages/family-settings-management';
import WelcomeOnboarding from './pages/welcome-onboarding';
import FamilyMessagingInterface from './pages/family-messaging-interface';
import NotificationSettingsManagement from './pages/notification-settings-management';
import IndividualProfileManagement from './pages/individual-profile-management';
import WeeklyMenuPlanning from './pages/weekly-menu-planning';
import FAQHelpCenter from './pages/faq-help-center';
import FamilyActivityReports from './pages/family-activity-reports';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import ForgotPassword from './pages/auth/ForgotPassword';
import { useAuth } from './contexts/AuthContext';
import MultiMemberTaskCoordination from './pages/multi-member-task-coordination';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/signin" replace />;
  }
  
  return children;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/welcome-onboarding" element={<WelcomeOnboarding />} />
        <Route path="/faq-help-center" element={<FAQHelpCenter />} />
        
        {/* Protected Routes */}
        <Route path="/" element={<ProtectedRoute><FamilyCalendarView /></ProtectedRoute>} />
        <Route path="/daily-task-management" element={<ProtectedRoute><DailyTaskManagement /></ProtectedRoute>} />
        <Route path="/family-calendar-view" element={<ProtectedRoute><FamilyCalendarView /></ProtectedRoute>} />
        <Route path="/long-term-task-planning" element={<ProtectedRoute><LongTermTaskPlanning /></ProtectedRoute>} />
        <Route path="/family-settings-management" element={<ProtectedRoute><FamilySettingsManagement /></ProtectedRoute>} />
        <Route path="/family-messaging-interface" element={<ProtectedRoute><FamilyMessagingInterface /></ProtectedRoute>} />
        <Route path="/notification-settings-management" element={<ProtectedRoute><NotificationSettingsManagement /></ProtectedRoute>} />
        <Route path="/individual-profile-management" element={<ProtectedRoute><IndividualProfileManagement /></ProtectedRoute>} />
        <Route path="/weekly-menu-planning" element={<ProtectedRoute><WeeklyMenuPlanning /></ProtectedRoute>} />
        <Route path="/family-activity-reports" element={<ProtectedRoute><FamilyActivityReports /></ProtectedRoute>} />
        <Route path="/multi-member-task-coordination" element={<ProtectedRoute><MultiMemberTaskCoordination /></ProtectedRoute>} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;